$(document).ready(function(){
    $('.header__icons.header__icons--localization.header-localization').insertBefore('nav.header__inline-menu');
    $('br').attr('aria-hidden','true');
    $('.slider-button.slider-button--prev').removeAttr('aria-controls');
    $('.privacy-policy.static-page table').attr('role','presentation');

    setTimeout(function() {
      $('.okeReviews-attributeRatingsTable').attr('role','presentation');
      $('button.thumbnail.global-media-settings.global-media-settings--no-shadow').removeAttr('aria-describedby');
      $('button.slider-button.slider-button--next').removeAttr('aria-controls');
      $('input.boost-sd__search-bar-input').attr('aria-label',' Enter to Find your Solemate');
      $('input.search__input').attr('aria-label','Enter');
      $('.cc-settings-view').removeAttr('aria-labelledby');
  }, 2000);
});


// Delay for section of splide slider on home
$(document).ready(function() {
    setTimeout(function() {
        $('h3, h4, h5, h6').each(function() {
            if (!$.trim($(this).text())) {
                $(this).remove();
            }
        });
        $('.splide__track.splide__track--loop').removeAttr('aria-live');
        $('.rewards-info-banner-img').attr('aria-hidden','true');
        $('.product-info h3').attr('aria-hidden','true');  
    }, 3000);
});
 
         //    Drawer  
$(document).ready(function () {
    $('#cart-icon-bubble').on('click', function () {
        $('.cart-drawer').attr('aria-hidden', 'false');
    });

    $('.drawer__close').on('click', function () {
        $('.cart-drawer').attr('aria-hidden', 'true');
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('.cart-drawer').attr('aria-hidden', 'true');
        }
    });
});

      // Currency selector
      $(document).ready(function () {
        const $disclosureButton = $('.disclosure__button');
        const $countryList = $('#CountryList');
  
        // Initially hide the country list
        $countryList.attr('aria-hidden', 'true');
  
        // Toggle dropdown on button click
        $disclosureButton.on('click', function () {
           const isExpanded = $(this).attr('aria-expanded') === 'true';
           $(this).attr('aria-expanded', !isExpanded);
           $countryList.attr('aria-hidden', isExpanded);
        });
  
        // Handle keyboard interaction for button
        $disclosureButton.on('keydown', function (e) {
           if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              $(this).click();
           }
        });
  
        // Close dropdown on Escape key
        $(document).on('keydown', function (event) {
           if (event.key === 'Escape') {
              $disclosureButton.attr('aria-expanded', 'false');
              $countryList.attr('aria-hidden', 'true');
           }
        });
     });

    //  Back To Top
    $(document).ready(function () {
      $(window).scroll(function () {
         if ($(this).scrollTop() > 20) {
            $("#back-to-top").fadeIn();
         } else {
            $("#back-to-top").fadeOut();
         }
      });
   });

// Splide Slider price label
$( document ).ready(function() {
      var existCondition = setInterval(function() {
       if ($('.item').length) { 
        clearInterval(existCondition);
        runMyFunction2();
       }
      }, 1000);

      function runMyFunction2(){
       console.log("Splide Slider");
       $('.item').each(function() {
        var priceElement = $(this).find('.product-price-wrap');
        var linkElement = $(this).find('div a');

        priceElement.insertAfter(linkElement);
    });
    $('.item a').each(function() {
      if (!$.trim($(this).text())) {
          $(this).remove();
      }
  });
      }
});

$( document ).ready(function() {
  var existCondition = setInterval(function() {
   if ($('.splide__track').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 2000);

  function runMyFunction2(){
   console.log("Splide Slider Prices");
$('.product-price-wrap .prod-price').prepend('<span class="visually-hidden">Sale Price</span>');
$('.product-price-wrap .prod-list-price').prepend('<span class="visually-hidden">Original Price</span>');
$('.splide__track.splide__track--loop').removeAttr('aria-live');
$('.img-wrapper img.main-img').attr('aria-hidden','true');
  }
}); 